const WINDOWS_1252_BYTES = {
  '\u20AC': 0x80,
  '\u201A': 0x82,
  '\u0192': 0x83,
  '\u201E': 0x84,
  '\u2026': 0x85,
  '\u2020': 0x86,
  '\u2021': 0x87,
  '\u02C6': 0x88,
  '\u2030': 0x89,
  '\u0160': 0x8A,
  '\u2039': 0x8B,
  '\u0152': 0x8C,
  '\u017D': 0x8E,
  '\u2018': 0x91,
  '\u2019': 0x92,
  '\u201C': 0x93,
  '\u201D': 0x94,
  '\u2022': 0x95,
  '\u2013': 0x96,
  '\u2014': 0x97,
  '\u02DC': 0x98,
  '\u2122': 0x99,
  '\u0161': 0x9A,
  '\u203A': 0x9B,
  '\u0153': 0x9C,
  '\u017E': 0x9E,
  '\u0178': 0x9F,
};

const MOJIBAKE_MARKER = /[\u00C2\u00C3\u00D8\u00D9]|â[\u20AC\u2018\u2019\u201C\u201D\u2122]/;

const toByte = (character) => {
  const codePoint = character.codePointAt(0);
  if (codePoint <= 0xFF) return codePoint;
  return WINDOWS_1252_BYTES[character];
};

/**
 * Repairs text that was accidentally read as Windows-1252 instead of UTF-8.
 * Correct UTF-8 text, including Arabic, is returned untouched.
 */
export const repairMojibake = (value) => {
  if (typeof value !== 'string' || !MOJIBAKE_MARKER.test(value)) return value;

  const bytes = [];
  for (const character of value) {
    const byte = toByte(character);
    if (byte === undefined) return value;
    bytes.push(byte);
  }

  try {
    const encodedBytes = bytes.map((byte) => `%${byte.toString(16).padStart(2, '0')}`).join('');
    return decodeURIComponent(encodedBytes);
  } catch {
    return value;
  }
};
